/* eslint-disable */
import React from "react"
import { graphql } from 'gatsby'
import Layout from '../../components/theme/Layout'
import Footer from '../../components/theme/Footer'
import Header from '../../components/theme/Header'
import RenderBlock from '../../components/blocks/RenderBlock'

import EventTracker from "../../components/common/EventTracker";
import Offers from "../../components/common/Offers";
import ImageAndText from "../../components/common/ImageAndText";

import image3 from '../../../static/images/Web_ClusterPacks_Purr-oudlyCanadian.jpg';
import image4 from '../../../static/images/Royale-ABOUTPAGE-CNImage.jpg';
import image5 from '../../../static/images/Royale-ABOUTPAGE-KittenImage.jpg';

const AboutRoyale = ({ data }) => {
  let image3Text = [
    {
      "__typename": "HeaderBlock",
      "type": "h2",
      "title": "Une entreprise fièrement canadienne",
      "guid": "image3header"
    },
    {
      "__typename": "TextBlock",
      "text": "<p>Nous sommes une entreprise fièrement canadienne qui, depuis des décennies, contribue au confort des foyers canadiens d’un bout à l’autre du pays.</p><p>Le papier hygiénique, les mouchoirs, les serviettes de table Royale<sup>®</sup> – et même nos couches Premium – sont fabriqués par une fière entreprise canadienne.</p><p>Ce sentiment se reflète aussi dans notre engagement à soutenir les emplois locaux et nos collectivités. Et nous sommes aussi fiers de garder notre siège social en sol canadien.</p>",
      "guid": "image3text"
    }
  ];

  let image4Text = [
    {
      "__typename": "HeaderBlock",
      "type": "h2",
      "title": "Qualité éprouvée.<br> Neutre en carbone.",
      "guid": "image4header"
    },
    {
      "__typename": "TextBlock",
      "text": "<p>Avec Royale<sup>®</sup>, on peut se soucier de l’environnement sans faire de compromis sur la qualité. Les forêts sous la gestion de J.D. Irving, Limited et de ses sociétés affiliées retirent chaque année de l’atmosphère une plus grande quantité de carbone que celle émise durant le cycle de vie des produits de papier Royale<sup>®</sup> vendus la même année.*</p><p>Depuis 1957, J.D. Irving, Limited et ses société affiliées ont planté plus d’un milliard d’arbres et elles continuent d’en planter des millions chaque année.</p>",
      "guid": "image4text"
    }
  ];

  let image5Text = [
    {
      "__typename": "HeaderBlock",
      "type": "h2",
      "title": "Voici les chatons Royale<sup>®</sup>",
      "guid": "image5header"
    },
    {
      "__typename": "TextBlock",
      "text": "<p>Les chatons emblématiques Royale<sup>®</sup> sont au cœur même de notre marque. Ces charmantes mascottes poilues sont inspirées de la sensation qui accompagne nos produits de papier – la douceur chatonne<sup>MC</sup>!</p>",
      "guid": "image5text"
    }
  ];

  // Remove some content blocks
  // I do not want to remove them from Episerver because the client will ask us to put them all back
  // Just remove this when we need to put the content back
  const blocks = data.defaultPage.blocks;
  blocks.shift();
  blocks.shift();
  blocks.shift();
  blocks.shift();
  blocks.shift();

  const urls = data.defaultPage.urls;
  urls.en = '/about'
  urls.fr = '/fr/a-propos-de-royale'

  return (
    <Layout
      meta={data.defaultPage.meta}
      urls={urls}
      locale='fr'
    >
      <Header
        urls={urls}
        locale='fr'
      />
      <main>
        <ImageAndText img={image3} content={image3Text} />
        <ImageAndText reverse blueBg img={image4} content={image4Text} />
        <ImageAndText img={image5} content={image5Text} />
        <RenderBlock blocks={blocks} main={false} />
      </main>

      <EventTracker gtag={{'allow_custom_scripts': true,'send_to': 'DC-8521957/invmedia/tiger0+standard'}} />
      <img height="1" width="1" style={{"border-style":"none"}} alt="Royale" src="https://insight.adsrvr.org/track/pxl/?adv=7c99unf&ct=0:14yinok&fmt=3" />
      <Offers />
      <Footer showExtraLegal extraRules={
          '*Les produits de papier Royale<sup>®</sup> sont fabriqués par Les Produits de consommation Irving Limitée et Irving Consumer Products, Inc., des sociétés affiliées à J.D. Irving, Limited.<br>' +
          '*Vérifié par un tiers'
        } />
    </Layout>
  )
}

export const query = graphql`
query {
  defaultPage(guid: { eq:"5c1c9570-0086-4a6f-ac11-7460dc6481ac"}, locale: {eq:"fr"}) {
    title
    title_html
    subtitle
    description
    image_url
    blocks {
      __typename
      ...textBlockFragment
      ...imageLeftTextRightBlockFragment
      ...imageRightTextLeftBlockFragment
      ...videoBlockFragment
      ...imageBlockFragment
      ...threeColumnWithIconsBlockFragment
    }
    urls {
      en
      fr
      zh_hant
      zh_hans
    }
    meta {
      description
      keywords
      title
    }
  }
}
`

export default AboutRoyale
